import React, { PureComponent } from 'react';
import { Trans, t } from '@lingui/macro';

import Chart from '../utils/chartjs';

import chartOptionsGen from '../utils/chartOptionsGen';
import { toPercent } from '../utils';

class SystemMovingTimeRange extends PureComponent {
    constructor(props) {
        super(props);
        this.height = props.isMobile ? '200px' : '300px';
        this.graphRefs = React.createRef();
    }

    componentDidMount() {
        this.drawChart();
    }

    componentWillReceiveProps() {
        this.drawChart();
    }

    drawChart = () => {
        const data = this.countData();
        const labels = Object.keys(data);
        const datasets = Object.values(data);
        const sum = datasets.reduce((s, value) => s + value, 0);
        if (this.chart) {
            this.chart.data.datasets = this._genDatasets(datasets);
            this.chart.update();
        } else {
            const options = chartOptionsGen.options('black', {
                xAxes: {
                    ticks: {
                        autoSkip: true,
                        maxTicksLimit: 13,
                    },
                },
            });
            const ctx = this.graphRefs.current.getContext('2d');
            this.chart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels,
                    datasets: this._genDatasets(datasets),
                },
                options: {
                    ...options,
                    maintainAspectRatio: false,
                    tooltips: {
                        callbacks: {
                            title: (tooltipItem) => {
                                let { xLabel } = tooltipItem[0];
                                if (xLabel !== '120+') {
                                    xLabel = parseInt(xLabel, 10);
                                    xLabel = `${xLabel} - ${xLabel + 1}`;
                                }
                                return `${xLabel} ${t({ id: 'common.minutes' })}`;
                            },
                            label: (tooltipItem) => {
                                const { yLabel } = tooltipItem;
                                return `${t({ id: 'tooltip.trip' })}: ${yLabel} (${toPercent(
                                    yLabel / sum,
                                )})`;
                            },
                        },
                    },
                },
            });
        }
    }

    countData = () => {
        const { data } = this.props;
        const reCategoryData = {};
        for (let i = 0; i <= 120; i += 1) reCategoryData[i] = 0;

        reCategoryData['120+'] = 0;
        for (const min in data) {
            const value = data[min];
            if (min <= 120 && min >= 0) reCategoryData[min] = value;
            else if (min >= 0) reCategoryData['120+'] += value;
        }
        return reCategoryData;
    }

    _genDatasets = (datasets) => [
        chartOptionsGen.genData(
            {
                data: datasets,
                bkgColor: 'rgba(54, 162, 235, 1)',
                borderColor: 'rgba(54, 162, 235, 1)',
                hoverBackgroundColor: 'rgba(54, 162, 235, 1)',
                hoverBorderColor: 'rgba(54, 162, 235, 1)',
                label: t({ id: 'common.transaction' }),
            },
        ),
    ]

    render() {
        return (
            <div className="mb-3">
                <h4 className="system-head" style={{ textAlign: 'left' }}>
                    <Trans id="system.tripDurationByMinutes" />
                </h4>
                <div style={{ position: 'relative', height: this.height }}>
                    <canvas ref={this.graphRefs} />
                </div>
            </div>
        );
    }
}

export default (SystemMovingTimeRange);
